import Cookies from 'js-cookie'
import { useMemo } from 'react'
import useSWR from 'swr'
import type { SWRConfiguration } from 'swr/_internal'
import type { Schema, z } from 'zod'

import { fetcher } from './fetcher.ts'
import type { Options } from './types.ts'

export type FetcherArgs<I extends Schema, O extends Schema> = [url: string, options: Options<I, O>]

/**
 * This hook encapsulates all logic we need for sending requests to Cake, for endpoints that
 * do not require a workspace slug.
 */
export function useApiSWR<I extends Schema, O extends Schema>(
  url: string | null,
  options?: Options<I, O>,
  swrConfig?: SWRConfiguration<z.infer<O>>,
) {
  const token = Cookies.get('csrfToken2')
  const resolvedOptions = useMemo(() => ({ ...(options ?? {}), token }), [options, token])

  return useSWR<z.infer<O>, Error, FetcherArgs<I, O> | null>(
    url ? [url.startsWith('/') ? url : `/${url}`, resolvedOptions] : null,
    (args) => fetcher(...args),
    swrConfig,
  )
}
